//** deals Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
import { setLoading } from '../../../@core/components/skelton/store';
import queryString from 'query-string';
export const getCalendar = createAsyncThunk('calendarSlice/getCalendar', async (data, { dispatch }) => {
    try {
        const query = queryString.stringify(data);
        dispatch(setLoading(true));
        let response = await axios.get(`/calender${query ? `?${query}` : ''}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));

        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const calendarSlice = createSlice({
    name: 'calendarSlice',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCalendar.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    }
});

export default calendarSlice.reducer;
